<script lang="ts">
import { defineComponent, h, ref } from 'vue';

import {
  makeDisabledProps,
  makeLoadingProps,
  makeLocaleProps,
  makeReadonlyProps,
  makeSizeProps,
  makeThemeProps,
  useRender
} from '../../composable';

import TableProvider from './components/TableProvider';
import { makeTableProps } from './composable';
import { convertChildrenToColumn } from './utils';

import type { NTable } from './interface';

export const componentName = 'CdsTable';
export default defineComponent({
  name: componentName,
  inheritAttrs: false,
  props: {
    ...makeTableProps(),
    ...makeSizeProps(),
    ...makeLocaleProps(),
    ...makeLoadingProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeThemeProps()
  },
  emits: {
    /**
     * События изменения пагинации, фильтров или сортировки
     */
    change: (
      pagination: NTable.NPagination.IProps,
      filters: Record<string, NTable.TFilterValue | null>,
      sorter: NTable.ISorterResult | NTable.ISorterResult[],
      extra: NTable.ICurrentData
    ) => true,
    /**
     * Событие при раскрытии строки
     */
    expand: (expanded: boolean, record: NTable.TDefaultRecord) => true,
    /**
     * Событие изменения раскрытых строк
     */
    expandedRowsChange: (expandedKeys: NTable.TKey) => true,
    /**
     * Событие при изменении размера колонки
     */
    resizeColumn: (width: number, column: NTable.NColumn.IColumn) => true,
    /**
     * Событие текущих раскрытых строк
     */
    'update:expandedRowKeys': (expandedKeys: NTable.TKey[]) => true
  },
  setup(props, { attrs, slots }) {
    const table = ref();

    useRender(() => {
      const columns = props.columns || convertChildrenToColumn(slots.default?.());

      return h(
        TableProvider,
        {
          ref: table,
          ...attrs,
          ...props,
          columns: columns || [],
          expandedRowRender: slots.expandedRowRender,
          contextSlots: { ...slots }
        },
        slots
      );
    });

    return { table };
  }
});
</script>

<style lang="scss">
@import './CdsTable';
</style>
